var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-inline-flex tw-border-solid tw-border-border-color",class:_vm.dividerClasses})}
var staticRenderFns = []

export { render, staticRenderFns }